<template>  
  <v-layout wrap pa-3 >      
      <v-flex sm6 pl-2>
        <v-switch v-model="isOnGoingFiltered" :label="$t('Pilot.FleetDrawer.FilterOngoing')"></v-switch>
      </v-flex>
  </v-layout>
</template>
<script lang="ts">
  import Vue from 'vue'
  import Component from 'vue-class-component'  
   
  @Component({
    name: 'FleetFilter'
  })
  export default class FleetFilter extends Vue {        
    
    get filterFleet(){
      return this.$store.myGetters.filterFleet
    }
      
    get isOnGoingFiltered() {
      return this.filterFleet.onGoing
    }
    set isOnGoingFiltered(newValue) {            
      this.$store.myActions.FLEET_SET_ONGOING_FILTER(newValue)
    }
  } 
  
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  
</style>
